import { useEffect, useRef, useState } from "react"
import { Toast } from "primereact/toast"
import styles from "../../../styles/Participant-Employment.module.css"
import { LoaderMedium } from "../../../components/Loaders"
import { careerProfileLabels } from "../Types/careerProfileLabels"
import {
  formatToLocalDateTime,
  getStartAndEndDate,
  renderCareerViewTable,
} from "../Utils/Utils"
import { Button } from "primereact/button"
import CareerProfileViewTable from "./CareerProfileViewTable"
import ViewHeader from "../Utils/ViewHeader"

const CareerProfileView = ({
  initialData,
  data,
  setShowCareerForm,
  inactive,
  viewMode,
  closeViewMode,
}) => {
  const toast = useRef(null)
  const [loading, setLoading] = useState(false)
  const [initial, setInitial] = useState(null)

  useEffect(() => {
    setLoading(true)
    initialData.then((result) => {
      setInitial(result)
      setLoading(false)
    })
  }, [initialData])
  const initialTable = () => {
    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Date Completed</th>
            <th>Performed by</th>
            <th>Last updated</th>
            <th>Last updated by</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {formatToLocalDateTime(
                initial?.date_completed,
                "MM/dd/yyyy hh:mm a"
              )}
            </td>
            <td>{`${initial?.performed_by.first} ${initial?.performed_by.last}`}</td>
            <td>
              {formatToLocalDateTime(
                initial?.last_updated,
                "MM/dd/yyyy hh:mm a"
              )}
            </td>
            <td>{`${initial?.last_updated_by.first} ${initial?.last_updated_by.last}`}</td>
          </tr>
        </tbody>
      </table>
    )
  }
  const workGoalsTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.workGoals,
      "workGoals",
      data
    )
  }
  const educationTable = () => {
    return (
      <>
        {renderCareerViewTable(
          careerProfileLabels.education,
          "education",
          data
        )}
        {otherEducationTable()}
      </>
    )
  }
  const otherEducationTable = () => {
    return (
      <>
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {"Other education or training programs"}
        </h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Educational/training institution</th>
              <th>Years attended</th>
            </tr>
          </thead>
          <tbody>
            {data?.educationPrograms?.map((e) => {
              return (
                <tr key={e.id}>
                  <td>{e.name}</td>
                  <td>{getStartAndEndDate(e.startDate, e.endDate, "iso")}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </>
    )
  }
  const pastEducationTable = () => {
    return (
      <>
        {renderCareerViewTable(
          careerProfileLabels.pastEducationExperiences,
          "pastEducation",
          data
        )}
        {pastEducationLenguages()}
      </>
    )
  }
  const pastEducationLenguages = () => {
    const sectionFiltered = Object.entries(data).filter((w) =>
      w[0]?.startsWith("pastEducation14_")
    )
    return (
      <>
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {"What languages do you know?"}
        </h3>
        <table
          id={`${careerProfileLabels.pastEducationExperiences.pastEducation_14.label}`}
          className={styles.table}
        >
          <tbody>
            <tr>
              <th>
                {
                  careerProfileLabels.pastEducationExperiences.pastEducation_14
                    .label
                }
              </th>
            </tr>
            {sectionFiltered.map((s) => {
              if (Object.values(s)[1]) {
                return (
                  <tr>
                    <td>{`${
                      Object.values(s)[0].split("_")[1] !== "Other"
                        ? Object.values(s)[0].split("_")[1]
                        : data["pastEducation14a"]
                    } `}</td>
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </>
    )
  }
  const plansForSchoolTable = () => {
    return (
      <>
        {renderCareerViewTable(
          careerProfileLabels.plansForSchoolAndTraining,
          "plansForSchool",
          data
        )}
        {plansForSchoolNeeding()}
      </>
    )
  }
  const convertPlansForSchoolNeedingValues = (label, value) => {
    switch (label) {
      case "AccessToAComputer":
        return value && "Access to a computer"
      case "QuietPlaceToStudy":
        return value && "Quiet place to study"
      case "FinancialAid":
        return value && "Financial aid"
      case "MentalHealthSupport":
        return value && "Mental health support"
      case "HelpWithTransitRoute":
        return value && "Help with transit route"
      case "HelpWithStudyCalendar":
        return value && "Help with study calendar"
      case "HelpNavigatingCampus":
        return value && "Help with navigating campus"
      case "HelpTalkingToTeachers":
        return value && "Help talking to teachers"
      case "ComputingLiteracy":
        return value && "Computing literacy"
      case "TransitCard":
        return value && "Transit card"
      case "BookSupplies":
        return value && "Book supplies"
      case "ElderCare":
        return value && "Elder care"
      case "HelpStudying":
        return value && "Help Studying"
      case "ChildCare":
        return value && "Child care"
      case "MoreSupportFromFamily":
        return value && "More support from family"
      case "Other":
        return value

      default:
        break
    }
  }
  const plansForSchoolNeeding = () => {
    const sectionFiltered = Object.entries(data).filter((w) =>
      w[0]?.startsWith("plansForSchool1_")
    )
    return (
      <>
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {"What do you need in order to start school?"}
        </h3>
        <table
          id={`${careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1.label}`}
          className={styles.table}
        >
          <tbody>
            <tr>
              <th>
                {
                  careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1
                    .label
                }
              </th>
            </tr>
            {sectionFiltered.map((s) => {
              if (Object.values(s)[1]) {
                return (
                  <tr>
                    <td>
                      {` ${
                        Object.values(s)[0].split("_")[1] !== "Other"
                          ? convertPlansForSchoolNeedingValues(
                              Object.values(s)[0].split("_")[1],
                              Object.values(s)[1]
                            )
                          : data["plansForSchool1a"]
                      } `}
                    </td>
                  </tr>
                )
              }
            })}
          </tbody>
        </table>
      </>
    )
  }
  const workExperienceTable = () => {
    return (
      <>
        {renderCareerViewTable(
          careerProfileLabels.workExperience,
          "hadJob",
          data
        )}
        {otherWorkExperienceTable()}
      </>
    )
  }
  const otherWorkExperienceTable = () => {
    return (
      <>
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {"Past jobs"}
        </h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Employer</th>
              <th>Job title</th>
            </tr>
          </thead>
          <tbody>
            {data?.pastJobs?.map((e) => {
              return (
                <tr key={e.key}>
                  <td>{e.employer}</td>
                  <td>{e.jobTitle}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </>
    )
  }
  const militaryExperienceTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.militaryExperience,
      "military",
      data
    )
  }
  const culturalBackgroundTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.culturalBackground,
      "cultural",
      data
    )
  }
  const mentalHealthTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.mentalHealth,
      "mental",
      data
    )
  }
  const substanceUseTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.substanceUse,
      "substanceUse",
      data
    )
  }
  const physicalHealthTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.physicalHealth,
      "physical",
      data
    )
  }
  const cognitiveHealthTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.cognitiveHealth,
      "cognitive",
      data
    )
  }
  const gettingReadyJobTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.gettingReadyJob,
      "readyJob",
      data
    )
  }
  const interpersonalSkillsTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.interpersonalSkills,
      "interpersonalSkills",
      data
    )
  }
  const benefitsDetailsTable = (label, value, boolean) => {
    return (
      <table className={styles.table}>
        <tbody>
          <tr>
            <th>{label}</th>
          </tr>
          <tr>
            {boolean ? <td>{value ? "Yes" : "No"}</td> : <td>{value}</td>}
          </tr>
        </tbody>
      </table>
    )
  }
  const benefitsTable = () => {
    return (
      <>
        {benefitsDetailsTable(
          "Combat-related VA benefits",
          data?.benefitsCombatRelated,
          true
        )}
        {benefitsDetailsTable("Housing Subsidy", data?.benefitsHousing, true)}
        {benefitsDetailsTable("Medicare", data?.benefitsMedicare, true)}
        {benefitsDetailsTable("Retirement", data?.benefitsRetirement, true)}
        {benefitsDetailsTable("SSI", data?.benefitsSSI, true)}
        {benefitsDetailsTable(
          "Food Stamps/SNAP",
          data?.benefitsFoodStamps,
          true
        )}
        {benefitsDetailsTable("Medicaid", data?.benefitsMedicaid, true)}
        {benefitsDetailsTable(
          "Non-combat VA Benefits",
          data?.benefitsNonCombat,
          true
        )}
        {benefitsDetailsTable("SSDI", data?.benefitsSSDI, true)}
        {benefitsDetailsTable("TANF", data?.benefitsTANF, true)}
        {
          <table className={styles.table}>
            <tbody>
              <tr>
                <th>{"Other"}</th>
              </tr>
              <tr>
                {
                  <td>
                    {data?.benefitsOther
                      ? data?.benefitsOtherDesc
                      : data?.benefitsOther}
                  </td>
                }
              </tr>
            </tbody>
          </table>
        }
        {benefitsDetailsTable(
          careerProfileLabels.benefits.benefits_1.label,
          data?.benefits1
        )}
        {benefitsDetailsTable(
          careerProfileLabels.benefits.benefits_2.label,
          data?.benefits2
        )}
        {benefitsDetailsTable(
          careerProfileLabels.benefits.benefits_3.label,
          data?.benefits3
        )}
      </>
    )
  }
  const legalHistoryTable = () => {
    return (
      <>
        {renderCareerViewTable(careerProfileLabels.legalHistory, "legal", data)}
        {otherLegalTable()}
      </>
    )
  }
  const otherLegalTable = () => {
    return (
      <>
        <h3
          className={styles.view_subtitle}
          style={{
            color: "#383838",
            fontWeight: "600",
          }}
        >
          {"Past convictions"}
        </h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Year</th>
              <th>Type of conviction</th>
              <th>Sentence/Disposition</th>
            </tr>
          </thead>
          <tbody>
            {data?.convictions?.map((e) => {
              return (
                <tr key={e.id}>
                  <td>{e.year}</td>
                  <td>{e.type}</td>
                  <td>{e.sentence}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </>
    )
  }
  const dailyActivitiesTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.dailyActivities,
      "daily",
      data
    )
  }
  const otherNetworkingTable = () => {
    return renderCareerViewTable(
      careerProfileLabels.networkingContacts,
      "networking",
      data
    )
  }
  const networkingContactsTable = () => {
    return (
      <>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact type</th>
            </tr>
          </thead>
          <tbody>
            {data?.networkingContacts?.map((e) => {
              return (
                <tr key={e.name}>
                  <td>{e.name}</td>
                  <td>{e.type}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {
          <>
            <h3
              className={styles.view_subtitle}
              style={{
                color: "#383838",
                fontWeight: "600",
              }}
            >
              {"Other information"}
            </h3>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0rem",
              }}
            >
              {otherNetworkingTable()}
            </div>
          </>
        }
      </>
    )
  }
  return (
    <>
      <Toast ref={toast} position="top-right" />
      {loading ? (
        <LoaderMedium />
      ) : (
        <>
          <div className={styles.rounded_wrapper}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <ViewHeader
                viewMode={viewMode}
                title={"Career profile"}
                closeViewMode={closeViewMode}
              />
              <Button
                className={styles.edit_btn}
                onClick={() => {
                  setShowCareerForm(true)
                }}
                disabled={inactive || viewMode?.view}
              />
            </div>
            {
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                ></div>
                {initialTable()}
              </>
            }
            {
              <CareerProfileViewTable
                content={workGoalsTable}
                label={"Work goals"}
              />
            }
            {
              <CareerProfileViewTable
                content={educationTable}
                label={"Education"}
              />
            }
            {
              <CareerProfileViewTable
                content={pastEducationTable}
                label={"Past education experiences"}
                educationButton
              />
            }
            {
              <CareerProfileViewTable
                content={plansForSchoolTable}
                label={"Plans for school and training"}
                educationButton
              />
            }
            {
              <CareerProfileViewTable
                content={workExperienceTable}
                label={"Work experience"}
              />
            }
            {
              <CareerProfileViewTable
                content={militaryExperienceTable}
                label={"Military experience"}
              />
            }
            {
              <CareerProfileViewTable
                content={culturalBackgroundTable}
                label={"Cultural background"}
              />
            }
            {
              <CareerProfileViewTable
                content={mentalHealthTable}
                label={"Mental health"}
              />
            }
            {
              <CareerProfileViewTable
                content={substanceUseTable}
                label={"Substance use"}
              />
            }
            {
              <CareerProfileViewTable
                content={physicalHealthTable}
                label={"Physical health"}
              />
            }
            {
              <CareerProfileViewTable
                content={cognitiveHealthTable}
                label={"Cognitive health"}
              />
            }
            {
              <CareerProfileViewTable
                content={gettingReadyJobTable}
                label={"Getting ready for a job"}
              />
            }
            {
              <CareerProfileViewTable
                content={interpersonalSkillsTable}
                label={"Interpersonal skills"}
              />
            }
            {
              <CareerProfileViewTable
                content={benefitsTable}
                label={"Benefits"}
              />
            }
            {
              <CareerProfileViewTable
                content={legalHistoryTable}
                label={"Legal history"}
              />
            }
            {
              <CareerProfileViewTable
                content={dailyActivitiesTable}
                label={"Daily activities"}
              />
            }
            {
              <CareerProfileViewTable
                content={networkingContactsTable}
                label={"Networking contacts"}
              />
            }
          </div>
        </>
      )}
    </>
  )
}
export default CareerProfileView
